import { useState, useCallback, type ReactNode } from "react";

type ToastItem = { id: number; message: string; type: "success" | "error" };

let _show: ((msg: string, type: ToastItem["type"]) => void) | null = null;

export function toast(message: string, type: ToastItem["type"] = "success") {
  _show?.(message, type);
}

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<ToastItem[]>([]);

  const show = useCallback((message: string, type: ToastItem["type"]) => {
    const id = Date.now();
    setItems((prev) => [...prev, { id, message, type }]);
    setTimeout(() => setItems((prev) => prev.filter((t) => t.id !== id)), 3500);
  }, []);

  _show = show;

  return (
    <>
      {children}
      <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 100, display: "flex", flexDirection: "column", gap: 8 }}>
        {items.map((t) => (
          <div key={t.id} style={{
            padding: "12px 16px",
            borderRadius: 8,
            fontSize: 14,
            fontWeight: 500,
            color: "#fff",
            background: t.type === "success" ? "#0f766e" : "#dc2626",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          }}>
            {t.message}
          </div>
        ))}
      </div>
    </>
  );
}
